export default __webpack_public_path__ + "static/media/DeleteButtonSVG.dd5053b3.svg";